
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SolutionsSection from './components/SolutionsSection';
import StatsSection from './components/StatsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <SolutionsSection />
        <StatsSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
